import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const FR_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "La Briscola comme vous ne l'avez jamais vue : RPG, Waifu et IA.",
      ctaWeb: "Jouer sur le Web",
      ctaAndroid: "Télécharger pour Android",
      version: "Version 2.3",
      badge: "✨ Nouveau Mode Donjon"
    },
    stats: {
      downloads: "Téléchargements",
      downloadsValue: ["Tu les comptes pas !", "Serveurs Pleins", "Un tas !", "Plus de 9000", "Trop pour compter"],
      hands: "Mains Perdues",
      handsValue: ["Trop...", "Manque de Skill", "C'est le Lag", "Tu pleures encore", "Réessaie tu auras plus de chance"],
      rating: "Évaluation",
      ratingValue: ["Ma grand-mère approuve", "11/10 - IGN", "Mieux que la pizza", "GOTY 2026", "Chef-d'œuvre absolu"],
      waifus: "Waifu",
      waifusValue: ["Toutes pour toi", "Seulement 2D > 3D", "Collectionne-les toutes !", "Waifu > Meta", "Le vrai trésor"]
    },
    features: {
      title: "Bien plus qu'un jeu de cartes",
      items: [
        { id: "classic", title: "Briscola Classique", description: "L'expérience originale, parfaite et propre.", icon: "🃏" },
        { id: "roguelike", title: "RPG Roguelike", description: "Gravissez la tour, obtenez des pouvoirs élémentaires et vainquez les boss.", icon: "⚔️" },
        { id: "ai", title: "IA Vivante", description: "Grâce à Google Gemini, les adversaires vous insultent ou vous louent en temps réel.", icon: "🧠" },
        { id: "gacha", title: "Système Gacha", description: "Utilisez les pièces pour débloquer de nouveaux skins et des fonds rares.", icon: "💎" },
        { id: "dungeon", title: "Mode Donjon", description: "Affrontez des boss avec des règles folles. Une défaite et c'est fini.", icon: "🏰" },
        { id: "puzzle", title: "Mode Puzzle", description: "Résolvez des scénarios complexes avec des objectifs spécifiques.", icon: "🧩" }
      ]
    },
    video: { title: "Trailer de Gameplay" },
    waifus: {
      title: "Choisissez votre Compagne",
      subtitle: "Chaque personnage a une personnalité unique, un doublage et un style de jeu.",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "La Douce", personality: "Douce et solaire, elle aime rester près de toi." },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "L'Analytique", personality: "Calculatrice et froide. Que de la logique." },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "La Tsundere", personality: "Compétitive et fougueuse. Elle déteste perdre." },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "La Reine", personality: "La sombre reine des cartes." },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "La Guide", personality: "Votre guide fidèle... peut-être." }
      ]
    },
    reviews: {
      title: "Ils disent de nous (malheureusement)",
      items: getCommonReviews('fr')
    },
    ctaStrip: {
      title: "Prêt à entrer en jeu ?",
      subtitle: "Rejoignez d'autres joueurs et commencez votre aventure aujourd'hui.",
      button: "Commencer à Jouer Maintenant"
    },
    footer: { privacy: "Confidentialité", terms: "Termes", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Politique de Confidentialité de Waifu Briscola",
      lastUpdated: "Dernière mise à jour : 25 Mai 2024",
      intro: "Cette Politique de Confidentialité décrit comment vos informations sont gérées lorsque vous utilisez l'application Waifu Briscola ('Service').",
      sections: [
        {
          title: "Informations que nous recueillons",
          intro: "Pour améliorer votre expérience, nous utilisons des services tiers qui peuvent recueillir des informations :",
          items: [
            "Données d'utilisation (PostHog) : Nous recueillons des données analytiques anonymes ou pseudonymes sur votre interaction avec le jeu. Cela inclut des événements comme le début d'une partie, les cartes jouées et les résultats finaux. Ces données nous aident à comprendre comment le jeu est utilisé et comment l'améliorer. Nous ne recueillons pas d'informations personnelles identifiables (PII) via PostHog.",
            "Interactions avec l'IA (Google Gemini) : Les messages de chat que vous envoyez et les informations sur l'état du jeu (comme les cartes dans votre main et sur la table) sont envoyés à l'API de Google Gemini pour générer les réponses et les coups de l'IA. Ces interactions sont soumises à la Politique de Confidentialité de Google. Nous n'envoyons aucune information personnelle à Google autre que le contenu de vos interactions de jeu.",
          ],
        },
        {
          title: "Comment nous utilisons vos informations",
          intro: "Nous utilisons les informations recueillies pour :",
          items: [
            "Fournir, exploiter et maintenir notre Service.",
            "Améliorer, personnaliser et étendre notre Service.",
            "Comprendre et analyser comment vous utilisez notre Service.",
            "Prévenir les abus et assurer la sécurité.",
          ],
        },
        {
          title: "Partage des informations",
          body: "Nous ne partageons vos informations personnelles avec personne, sauf avec les fournisseurs de services tiers (PostHog, Google) nécessaires au fonctionnement de l'application, comme décrit ci-dessus.",
        },
        {
          title: "Sécurité des données",
          body: "La sécurité de vos informations est importante pour nous, mais rappelez-vous qu'aucune méthode de transmission sur Internet ou méthode de stockage électronique n'est sûre à 100%.",
        },
        {
          title: "Modifications de cette Politique de Confidentialité",
          body: "Nous pouvons mettre à jour notre Politique de Confidentialité de temps à autre. Nous vous informerons de tout changement en publiant la nouvelle Politique de Confidentialité sur cette page.",
        },
        {
          title: "Contactez-nous",
          body: "Si vous avez des questions sur cette Politique de Confidentialité, vous pouvez contacter le responsable Mauro Mazzocchetti.",
        },
      ],
    },
    consent: { text: "Nous utilisons des cookies et des données analytiques pour améliorer le site. En continuant, vous acceptez notre", ok: "Compris" },
    terms: {
      title: "Termes et Conditions de Waifu Briscola",
      lastUpdated: "Dernière mise à jour : 25 Mai 2024",
      contact: "Responsable : Mauro Mazzocchetti",
      intro: "Bienvenue sur Waifu Briscola ! Ces termes et conditions décrivent les règles d'utilisation de l'application Waifu Briscola ('Service').",
      sections: [
        {
          title: "Acceptation des Termes",
          body: "En accédant et en utilisant ce Service, vous acceptez d'être lié par ces Termes. Si vous n'êtes pas d'accord avec une partie des termes, vous ne pouvez pas utiliser le Service.",
        },
        {
          title: "Utilisation du Service",
          body: "Vous acceptez de ne pas utiliser le Service à des fins illégales ou non autorisées. Vous êtes responsable de votre conduite et de tout contenu que vous fournissez lors de l'utilisation du Service, y compris les messages de chat.",
        },
        {
          title: "Contenu Généré par l'IA",
          intro: "Le Service utilise des modèles d'intelligence artificielle (Google Gemini) pour générer des réponses, des commentaires et des coups de jeu. Vous reconnaissez que :",
          items: [
            "Le contenu généré par l'IA est produit par un modèle et peut ne pas toujours être précis, approprié ou cohérent.",
            "Nous ne sommes pas responsables du contenu généré par l'IA.",
            "Les interactions avec l'IA sont destinées uniquement à des fins de divertissement.",
          ],
        },
        {
          title: "Limitation de Responsabilité",
          body: "En aucun cas Mauro Mazzocchetti, ni ses partenaires, ne seront responsables de tout dommage indirect, accessoire, spécial, consécutif ou punitif, y compris, sans limitation, la perte de profits, de données, de fonds de commerce ou d'autres pertes immatérielles, résultant de (i) votre accès ou utilisation ou incapacité d'accéder ou d'utiliser le Service ; (ii) tout contenu obtenu du Service.",
        },
        {
          title: "Modifications des Termes",
          body: "Nous nous réservons le droit, à notre seule discrétion, de modifier ou de remplacer ces Termes à tout moment. Nous vous informerons de tout changement en publiant les nouveaux termes sur cette page.",
        },
        {
          title: "Loi Applicable",
          body: "Ces Termes seront régis et interprétés conformément aux lois italiennes, sans égard à ses dispositions sur les conflits de lois.",
        },
      ],
    }
};
